export const all = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 155,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'Created',
    accessor: 'rfqCreateDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 110,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Status',
    accessor: 'status',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Awardee',
    accessor: 'companyName',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Awarded Date',
    accessor: 'awardDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Archived Date',
    accessor: 'archiveDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const drafts = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Part Number',
    accessor: 'partNum',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Part Description',
    accessor: 'partDesc',
    width: 160,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Solicitation #',
    accessor: 'solNum',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NIIN/NSN',
    accessor: 'niin',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'Modified By',
    accessor: 'email',
    width: 155,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 110,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Status',
    accessor: 'status',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const submitted = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Part Number',
    accessor: 'partNum',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Part Description',
    accessor: 'partDesc',
    width: 160,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Solicitation #',
    accessor: 'solNum',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NIIN/NSN',
    accessor: 'niin',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 155,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 110,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Status',
    accessor: 'status',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const rfr = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Part Number',
    accessor: 'partNum',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Part Description',
    accessor: 'partDesc',
    width: 160,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Solicitation #',
    accessor: 'solNum',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NIIN/NSN',
    accessor: 'niin',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 155,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
    width: 110,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'RFQ Status',
    accessor: 'status',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

// archiveDate: null
// awardDate: null
// companyName: null
// description: "New RFQ"
// email: "test@test.com"
// modified: "2020-09-29"
// niin: null
// partDesc: null
// partNum: null
// quoteDueDate: null
// rfqCreateDate: "2020-08-19"
// rfqId: 2
// solNum: null
// status: "Draft"

export const awarded = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Part Number',
    accessor: 'partNum',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Part Description',
    accessor: 'partDesc',
    width: 160,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Solicitation #',
    accessor: 'solNum',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'NIIN/NSN',
    accessor: 'niin',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 155,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'Created',
    accessor: 'rfqCreateDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'Awardee',
    accessor: 'companyName',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Awarded Date',
    accessor: 'awardDate',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];

export const archived = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
    width: 120,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified By',
    accessor: 'email',
    width: 155,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'Created',
    accessor: 'rfqCreateDate',
    width: 100,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
    width: 90,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'RFQ Status',
    accessor: 'status',
    width: 80,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },

  {
    Header: 'Archived Date',
    accessor: 'archiveDate',
    width: 150,
    style: { whiteSpace: 'normal', wordWrap: 'break-word' },
  },
];



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/ColumnGrids/RFQColumns.jsx